import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from '../locales/ar.json';
import en from '../locales/en.json';

const saved = (() => {
  try {
    return localStorage.getItem('rfleet.lang');
  } catch {
    return null;
  }
})();

void i18n.use(initReactI18next).init({
  resources: { ar: { translation: ar }, en: { translation: en } },
  lng: saved === 'en' ? 'en' : 'ar',
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
});

export function applyDirection(lang: string): void {
  const dir = lang === 'en' ? 'ltr' : 'rtl';
  document.documentElement.lang = lang;
  document.documentElement.dir = dir;
}
applyDirection(i18n.language);
i18n.on('languageChanged', (l) => {
  applyDirection(l);
  try {
    localStorage.setItem('rfleet.lang', l);
  } catch {
    /* ignore */
  }
});

export default i18n;
